/* Sleebo Nuit — animations & human touches. Runs after sleebo-nuit.js (DOMContentLoaded). */
(function(){
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (!reduce) document.documentElement.classList.add('sn-motion');

  function onReady(fn){ if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }

  onReady(function(){
    var now = new Date(), h = now.getHours(), m = now.getMinutes();
    var hhmm = h + ' h ' + (m < 10 ? '0' : '') + m;

    /* ---------- 1. Time-aware greeting ---------- */
    var hero = document.querySelector('.sn-hero');
    if (hero){
      var msg;
      if (h >= 22 || h < 5) msg = 'Il est <b>' + hhmm + '</b>. Encore réveillé&nbsp;? On a peut-être la solution.';
      else if (h < 11) msg = 'Bonjour. Il est <b>' + hhmm + '</b>&nbsp;— comment était votre nuit&nbsp;?';
      else if (h < 18) msg = 'Il est <b>' + hhmm + '</b>. Ce soir, dormez mieux.';
      else msg = 'Bonsoir. Il est <b>' + hhmm + '</b>, bientôt l’heure de dormir.';
      var g = document.createElement('p'); g.className = 'sn-greet'; g.innerHTML = '<i aria-hidden="true"></i><span>' + msg + '</span>';
      var wrap = hero.querySelector('.sn-wrap'); if (wrap) wrap.insertBefore(g, wrap.firstChild);
    }

    /* ---------- 2. Night strip: highlight the closest hour ---------- */
    var cells = [].slice.call(document.querySelectorAll('.sn-night .sn-cell'));
    if (cells.length){
      var best = null, bestD = 99;
      cells.forEach(function(c){
        var t = parseInt((c.querySelector('.sn-t') || {}).textContent, 10); if (isNaN(t)) return;
        var d = Math.abs(t - h); d = Math.min(d, 24 - d);
        if (d < bestD){ bestD = d; best = c; }
      });
      if (best && bestD <= 2) best.classList.add('is-now');
    }

    if (reduce) return;

    /* ---------- 3. Hero title word by word ---------- */
    var h1 = hero && hero.querySelector('h1');
    if (h1){
      var i = 0;
      [].slice.call(h1.childNodes).forEach(function(node){
        if (node.nodeType === 3){
          var frag = document.createDocumentFragment();
          node.textContent.split(/(\s+)/).forEach(function(part){
            if (!part) return;
            if (/^\s+$/.test(part)){ frag.appendChild(document.createTextNode(part)); return; }
            var s = document.createElement('span'); s.className = 'sn-w'; s.style.setProperty('--i', i++); s.textContent = part; frag.appendChild(s);
          });
          node.parentNode.replaceChild(frag, node);
        } else if (node.nodeType === 1){
          node.classList.add('sn-w'); node.style.setProperty('--i', i++);
        }
      });
      h1.classList.add('sn-split');
    }

    /* ---------- 4. Moon parallax + cursor glow + shooting stars ---------- */
    var moon = document.querySelector('.sn .sn-moon');
    if (moon){
      var ticking = false;
      window.addEventListener('scroll', function(){
        if (ticking) return; ticking = true;
        requestAnimationFrame(function(){ moon.style.setProperty('--sn-par', Math.min(window.scrollY * 0.25, 220) + 'px'); ticking = false; });
      }, { passive: true });
    }
    if (hero && finePointer){
      hero.addEventListener('pointermove', function(e){
        var r = hero.getBoundingClientRect();
        hero.style.setProperty('--mx', (e.clientX - r.left) + 'px');
        hero.style.setProperty('--my', (e.clientY - r.top) + 'px');
      });
    }
    if (hero){
      var shoot = function(){
        if (document.hidden) return;
        var s = document.createElement('span'); s.className = 'sn-shoot';
        s.style.setProperty('--x', (5 + Math.random() * 55) + '%'); s.style.setProperty('--y', (5 + Math.random() * 40) + '%');
        hero.appendChild(s); setTimeout(function(){ s.remove(); }, 1500);
      };
      setTimeout(shoot, 2500); setInterval(shoot, 9000);
    }

    /* ---------- 5. Scroll reveal ---------- */
    var groups = [
      '.sn-trust .sn-it', '.sn-night .sn-cell', '.sn .sn-head', '.sn-pillow', '.sn-zone-list li',
      '.sn-cards figure', '.sn-compare .sn-col', '.sn-specs .sn-spec', '.sn-band', '.sn-faq details',
      '.sn-more .sn-eyebrow', '.sn-more h2', '.sn-guar div'
    ];
    var io = 'IntersectionObserver' in window ? new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if (e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }) : null;
    groups.forEach(function(sel){
      [].slice.call(document.querySelectorAll(sel)).forEach(function(el, idx){
        if (el.closest('.sn-hero')) return;
        el.classList.add('sn-rv'); el.style.setProperty('--d', idx % 6);
        if (io) io.observe(el); else el.classList.add('in');
      });
    });
    setTimeout(function(){ document.querySelectorAll('.sn-rv').forEach(function(el){ if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add('in'); }); }, 1500);

    /* ---------- 6. Night strip lights up hour after hour ---------- */
    var strip = document.querySelector('.sn-night');
    if (strip && io){
      new IntersectionObserver(function(es, obs){
        if (!es[0].isIntersecting) return; obs.disconnect();
        cells.forEach(function(c, k){ setTimeout(function(){ cells.forEach(function(o){ o.classList.remove('lit'); }); c.classList.add('lit'); }, 500 + k * 700); });
      }, { threshold: 0.5 }).observe(strip);
    }

    /* ---------- 7. Guided tour of the 5 zones ---------- */
    document.querySelectorAll('[data-sn-zones]').forEach(function(root){
      var btns = [].slice.call(root.querySelectorAll('.sn-zone-list button')); if (!btns.length) return;
      var timer = null, k = 0, stopped = false, auto = false;
      function stop(){ stopped = true; clearInterval(timer); }
      root.addEventListener('pointerdown', stop); root.addEventListener('keydown', stop);
      btns.forEach(function(b){ b.addEventListener('click', function(){ if (!auto) stop(); }); });
      new IntersectionObserver(function(es){
        var vis = es[0].isIntersecting;
        clearInterval(timer);
        if (vis && !stopped){
          timer = setInterval(function(){ k = (k + 1) % btns.length; auto = true; btns[k].click(); auto = false; }, 3200);
        }
      }, { threshold: 0.4 }).observe(root);
    });

    /* ---------- 8. Numbers count up ---------- */
    document.querySelectorAll('.sn-specs .sn-v').forEach(function(v){
      var tn = v.firstChild; if (!tn || tn.nodeType !== 3 || !('IntersectionObserver' in window)) return;
      var target = parseInt(tn.textContent, 10); if (isNaN(target)) return;
      tn.textContent = '0';
      new IntersectionObserver(function(es, obs){
        if (!es[0].isIntersecting) return; obs.disconnect();
        var t0 = null, dur = 1200;
        (function step(ts){
          if (!t0) t0 = ts; var p = Math.min((ts - t0) / dur, 1), e = 1 - Math.pow(1 - p, 3);
          tn.textContent = Math.round(target * e);
          if (p < 1) requestAnimationFrame(step);
        })(performance.now());
      }, { threshold: 0.6 }).observe(v);
    });

    /* ---------- 9. Magnetic buttons (desktop) ---------- */
    if (finePointer){
      document.querySelectorAll('.sn .sn-btn').forEach(function(b){
        b.addEventListener('pointermove', function(e){
          var r = b.getBoundingClientRect();
          b.style.transform = 'translate(' + ((e.clientX - r.left - r.width / 2) * 0.12) + 'px,' + ((e.clientY - r.top - r.height / 2) * 0.25) + 'px)';
        });
        b.addEventListener('pointerleave', function(){ b.style.transform = ''; });
      });
    }

    /* ---------- 10. Product feedback ---------- */
    var mainImg = document.querySelector('[data-sn-main]');
    if (mainImg && 'MutationObserver' in window){
      new MutationObserver(function(){ mainImg.classList.remove('sn-swap'); void mainImg.offsetWidth; mainImg.classList.add('sn-swap'); })
        .observe(mainImg, { attributes: true, attributeFilter: ['src'] });
    }
    var price = document.querySelector('.sn-pprice .sn-now');
    if (price && 'MutationObserver' in window){
      var last = price.textContent;
      new MutationObserver(function(){
        if (price.textContent === last) return; last = price.textContent;
        price.classList.remove('sn-bump'); void price.offsetWidth; price.classList.add('sn-bump');
      }).observe(price, { childList: true, characterData: true, subtree: true });
    }
    document.querySelectorAll('.sn form[id^="sn-product-form"]').forEach(function(f){
      f.addEventListener('submit', function(){
        var b = f.querySelector('[data-sn-add]'); if (!b) return;
        b.classList.add('is-loading'); var l = b.querySelector('[data-sn-label]'); if (l) l.textContent = 'Ajout en cours…';
      });
    });
  });
})();